// extracted by mini-css-extract-plugin
module.exports = {"dataProtectionContainer":"DataProtection_dataProtectionContainer__3DOmC"};